/**
 * @generated SignedSource<<24bedb57b708a33962986f676448892b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserMetadata_user$data = {
  readonly bio: string | null | undefined;
  readonly firstName: string;
  readonly lastName: string;
  readonly primaryPhoto: {
    readonly url: string;
  } | null | undefined;
  readonly slugId: string;
  readonly " $fragmentType": "UserMetadata_user";
};
export type UserMetadata_user$key = {
  readonly " $data"?: UserMetadata_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserMetadata_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserMetadata_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slugId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bio",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "primaryPhoto",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "7840870a3dd0c96e2e6c54a80186119d";

export default node;
